<template>

    <v-page fixed>

        <transition name="modal">
            <v-modal-trait-delete v-if="showModal === 'delete'" :trait="trait" />
        </transition>

        <v-page-header icon="fas fa-fingerprint">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'traits' }">Traits</router-link></v-breadcrumb-item>
                <v-breadcrumb-item v-if="trait">{{ trait.name }}</v-breadcrumb-item>
            </v-breadcrumb>
        </v-page-header>

        <v-page-filters>
            <v-identifier v-if="trait" :uuid="trait.id" />
            <v-button size="sm" @click.native="updateTrait" :loading="loading">Save Trait</v-button>
        </v-page-filters>

        <v-page-body>

            <v-page-section>
                <template #title>{{ trait.field }}</template>
                <template #body>
                    <v-form-group label="Name">
                        <v-input class="w-300" :model="trait.name" @input="params.name = $event"></v-input>
                    </v-form-group>
                    <v-form-group label="Type">
                        <v-select class="w-300" :model="params.type || 'string'" @input="setType($event)">
                            <option value="string">String</option>
                            <option value="number">Number</option>
                            <option value="boolean">Boolean</option>
                            <option value="date">Date</option>
                        </v-select>
                    </v-form-group>
                    <v-form-group label="Format" v-if="params.type === 'string'">
                        <v-select class="w-300" :model="params.format || 'text'" @input="params.format = $event">
                            <option value="text">Text</option>
                            <option value="email">Email</option>
                            <option value="url">URL</option>
                        </v-select>
                    </v-form-group>
                    <v-form-group label="Format" v-if="params.type === 'number'">
                        <v-select class="w-300" :model="params.format || 'numeric'" @input="params.format = $event">
                            <option value="numeric">Numeric</option>
                            <option value="currency">Currency</option>
                        </v-select>
                    </v-form-group>
                    <v-form-group label="Format" v-if="params.type === 'boolean'">
                        <v-select class="w-300" :model="params.format || 'yes-no'" @input="params.format = $event">
                            <option value="yes-no">Yes / No</option>
                            <option value="true-false">True / False</option>
                            <option value="on-off">On / Off</option>
                        </v-select>
                    </v-form-group>
                    <v-form-group label="Format" v-if="params.type === 'date'">
                        <v-select class="w-300" :model="params.format || 'date'" @input="params.format = $event">
                            <option value="date">Date Only</option>
                            <option value="date-time">Date + Time</option>
                            <option value="relative">Relative Time</option>
                        </v-select>
                    </v-form-group>
                    <v-form-group label="Description">
                        <v-textarea :rows="3" :model="params.description" @input="params.description = $event" />
                    </v-form-group>
                    <v-form-group label="Visibility">
                        <v-checkbox
                            class="mb-10"
                            label="Use in Customer Lists"
                            :model="params.visibility.list"
                            @input="params.visibility.list = $event">
                        </v-checkbox>
                        <v-checkbox
                            class="mb-10"
                            label="Use in Customer Profiles"
                            :model="params.visibility.profile"
                            @input="params.visibility.profile = $event">
                        </v-checkbox>
                        <v-checkbox
                            label="Use in Segments"
                            :model="params.visibility.segment"
                            @input="params.visibility.segment = $event">
                        </v-checkbox>
                    </v-form-group>
                </template>
            </v-page-section>

        </v-page-body>

    </v-page>

</template>

<script>

import ModalTraitDelete from '@modals/trait/ModalTraitDelete';
import TraitApi from '@api/TraitApi';

export default {

    components: {
        'v-modal-trait-delete': ModalTraitDelete,
    },

    data() {
        return {
            loading: false,
            trait: null,
            params: {},
        }
    },

    mounted() {
        this.getTrait();
    },

    methods: {

        setType(val) {
            let params = this.params;
            params.type = val;
            params.format = null;
            this.params = params;
        },

        getTrait() {
            this.$store.commit('loading', true);
            TraitApi.getTrait(this.$route.params.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.trait = response.data.data;
                    this.params = { ...this.trait };
                    this.$events.$emit('pageLoaded');
                })
                .catch(() => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        updateTrait() {
            this.loading = true;
            TraitApi.updateTrait(this.trait.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                })
                .catch((error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
